import { render, staticRenderFns } from "./QaBox.vue?vue&type=template&id=5cbf2674&scoped=true"
import script from "./QaBox.vue?vue&type=script&lang=js"
export * from "./QaBox.vue?vue&type=script&lang=js"
import style0 from "./QaBox.vue?vue&type=style&index=0&id=5cbf2674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf2674",
  null
  
)

export default component.exports